import { Injector } from '@angular/core';
import { ShellService } from '@mynexus/mfe-core';
import { SendFaxDmeposService } from '@products/dmepos/services/send-fax/send-fax-dmepos.service';
import { SendFaxPacService } from '@products/pac/services/send-fax/send-fax-pac.service';
import { SendFaxHHService } from '@products/hh/services/send-fax/send-fax-hh.service';
import { ProductNames } from '@mynexus/mynexus-ui-lib';

// TODO: Remove PAC Commercial after LOB migration
export default function (injector: Injector, shellService: ShellService) {
  switch (shellService.getAppName()) {
    case ProductNames.DMEPOS:
      return new SendFaxDmeposService(injector);
    case ProductNames.PACIM:
    case ProductNames.PacCommercial:
      return new SendFaxPacService(injector);
    case ProductNames.HomeHealth:
      return new SendFaxHHService(injector);
    default:
      throw new Error(`Unknown product name: ${shellService.getAppName()}`);
  }
}
